import * as yup from 'yup';

export const contactUsSchema = yup.object({
  full_name: yup.string().required('Full Name is required.'),
  email_address: yup
    .string()
    .email('Email Address is invalid.')
    .required('Email Address is required.'),
  mobile_number: yup.string().required('Phone Number is required.'),
  body: yup.string().required('Message is required.'),
});
